/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether a submission is scored by the judge alone or waits for a reviewer.
 * @export
 */
export const JudgingMode = {
    Automatic: 'automatic',
    Manual: 'manual'
} as const;
export type JudgingMode = typeof JudgingMode[keyof typeof JudgingMode];


export function instanceOfJudgingMode(value: any): boolean {
    for (const key in JudgingMode) {
        if (Object.prototype.hasOwnProperty.call(JudgingMode, key)) {
            if (JudgingMode[key as keyof typeof JudgingMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JudgingModeFromJSON(json: any): JudgingMode {
    return JudgingModeFromJSONTyped(json, false);
}

export function JudgingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JudgingMode {
    return json as JudgingMode;
}

export function JudgingModeToJSON(value?: JudgingMode | null): any {
    return value as any;
}

export function JudgingModeToJSONTyped(value: any, ignoreDiscriminator: boolean): JudgingMode {
    return value as JudgingMode;
}

